import axios from 'axios'

import type { Survey } from '@/types/types'

/**
 * Loads active surveys once for {@link TextareaWithVars} when using `customerApp(survey)` vars
 * (skips duplicate `/surveys` calls when passed as prefetched props).
 */
export function usePrefetchSurveysForTextareaVars() {
  const surveys = ref<Survey[] | null>(null)
  const isLoading = ref(false)
  const loadError = ref(false)

  const fetchSurveys = async () => {
    isLoading.value = true
    loadError.value = false
    try {
      const { data } = await axios.get<{ data: Survey[] }>('/surveys', {
        params: { per_page: 250, page: 1 }
      })
      surveys.value = (data.data.filter((s) => s.isActive && !s.isTerminated) ?? []) as Survey[]
    } catch {
      loadError.value = true
      surveys.value = null
    } finally {
      isLoading.value = false
    }
  }

  return { surveys: surveys as Ref<Survey[] | null>, isLoading, loadError, fetchSurveys }
}
